











import { useRouter } from "next/router";
import en from "../public/locales/en/common"
import he from "../public/locales/he/common";

const TRANSLATIONS = { en, he };

export default function useTranslation() {
  const router = useRouter();
  const { locale, asPath } = router;
  if (typeof document !== 'undefined') {
    document.cookie = `NEXT_LOCALE=${locale}; max-age=31536000; path=/`;
  }


  const setLocale = (locale) => router.push(asPath, asPath, { locale });

  const t = (keyString) => TRANSLATIONS[locale][keyString];

  return { t, locale, setLocale };
}